import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE02000S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
	const [activeTab, setActiveTab] = useState(0);

    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

	const handleTabClick = (index) => {
		setActiveTab(index);
	};

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>제품소개</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
				<a href="#none" onClick={toggleDropdown}>
					통합솔루션<span></span>
				</a>
				<ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
					<li>
						<Link to="/GNBPURE02001S">온라인대출</Link>
					</li>
					<li>
						<Link to="/GNBPURE02002S">스탁론</Link>
					</li>
					<li>
						<Link to="/GNBPURE02003S">NPL</Link>
					</li>
					<li>
						<Link to="/GNBPURE02004S">기관연계시스템</Link>
					</li>
					<li>
						<Link to="/GNBPURE02000S">통합솔루션</Link>
					</li>
				</ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>통합솔루션</h3>

				{/* 탭 메뉴 */}
				<div className="tabs ty02">
					<ul className="tab-item col03">
						<li className={activeTab === 0 ? "on" : ""}>
							<Link to="#" onClick={(e) => { e.preventDefault(); handleTabClick(0); }}>코어뱅킹(계정계)</Link>
						</li>
						<li className={activeTab === 1 ? "on" : ""}>
							<Link to="#" onClick={(e) => { e.preventDefault(); handleTabClick(1); }}>스마트뱅킹(채널)</Link>
						</li>
						<li className={activeTab === 2 ? "on" : ""}>
							<Link to="#" onClick={(e) => { e.preventDefault(); handleTabClick(2); }}>시스템구축방안</Link>
						</li>
					</ul>
				</div>

				{/* 코어뱅킹(계정계) */}
					{activeTab === 0 && (
						<div>
							<article>
								<p className="subtitle">중소형금융기관용 코어뱅킹시스템</p>
								<p className="txt-wrap">
									GnB & Pure의 중소형 금융기관용 차세대뱅킹시스템은 상호저축은행을 비롯한 중소형 금융기관에서
									최소의 투자비용으로 계정계 시스템을 구축할 수 있는 Component Module 타입의 차세대 종합금융시스템입니다.
								</p>
							</article>
							<article>
								<p className="subtitle">통합금융기관용 시스템 구성도</p>
								<img src="/asset/img/subC/img_product_01_1.png" alt="중소형 금융기관용 시스템 구성도" className="pc" />
								<img src="../../asset/img/subC/img_product_01_1_mo.png" alt="중소형 금융기관용 시스템 구성도 이미지" className="mo"/>
							</article>
							<article>
								<p className="subtitle">여신전문기관용 시스템 구성도</p>
								<img src="../../asset/pure/img/subC/img_product_01_3.png" alt="여신전문기관용 시스템 구성도 이미지" className="pc"/>
								<img src="../../asset/pure/img/subC/img_product_01_3_mo.png" alt="여신전문기관용 시스템 구성도 이미지" className="mo"/>
							</article>
							<article>
								<p className="subtitle">시스템 특장점</p>
								<div className="table-type table-row">
									<table>
										<caption>시스템 개요 안내표</caption>
										<colgroup>
										<col style={{ width: "25%" }} />
										<col style={{ width: "auto" }} />
										</colgroup>
										<tbody>
										<tr>
											<th scope="row">전체 시스템의 통합화</th>
											<td>
											전체 시스템을 통합화하여 HOST와의 단일 연결 채널 역할을 하며, 각종 응용시스템에서 기본
											Application만 두고 통합중계시스템에서 대부분의 Business Logic을 처리하여 응용시스템의 부하를
											최소화함
											</td>
										</tr>
										<tr>
											<th scope="row">전문 통합/표준화 전문관리</th>
											<td>
											전문관리 솔루션을 적용하여 다양한 기관과 시스템의 서로 다른 전문을 통합/표준화 및 기존 HOST와 동일한
											전문으로 변환하여 줌으로써, 기존 HOST의 Process 변경 없이 대외연계업무 구현 용이
											</td>
										</tr>
										<tr>
											<th scope="row">모니터링 기능</th>
											<td>전문 모니터링 솔루션을 적용, 모니터링 기능 제공으로 안정적인 시스템 운영 가능</td>
										</tr>
										<tr>
											<th scope="row">객체 지향의 개발환경 지원</th>
											<td>거래전문의 각각의 Component로 구성하고 이것을 Database화하여 관리함으로써 객체지향의 개발환경 지원</td>
										</tr>
										<tr>
											<th scope="row">개발 및 운영, 유지보수 용이</th>
											<td>
											전문매핑툴을 사용하여 개발 사용자가 여러 대외기관연계 업무 개발 시, 필요정보의 입력만으로도 전문관리 및
											자료집계, 대사, 정산의 모든 과정이 자동 구현됨으로 개발 및 운영, 유지보수가 매우 용이
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</article>
							<article>
								<p className="subtitle">BEFORE VS AFTER 차세대뱅킹시스템 구축전 vs 구축후</p>
								<img src="../../asset/img/subC/img_product_01_2.png" alt="중소형 금융기관용 차세대뱅킹시스템 구축전과 구축후 비교 이미지" className="pc"/>
								<img src="../../asset/img/subC/img_product_01_2_mo.png" alt="중소형 금융기관용 차세대뱅킹시스템 구축전과 구축후 비교 이미지" className="mo"/>
							</article>
						</div>
					)}

				{/* 스마트뱅킹(채널) */}
					{activeTab === 1 && (
						<div>
							<article>
							<p className="subtitle">스마트뱅킹 시스템</p>
							<p className="txt-wrap">
								GnB & Pure 스마트뱅킹 시스템은 최신 오픈소스 기반의 프레임워크를 활용하여 구축된 최적의 금융 플랫폼입니다.
							</p>
							</article>
							<article>
							<p className="subtitle">시스템 개요</p>
							<img src="/asset/img/subC/img_smartbanking_01.png" alt="시스템구축방안 방식에 대한 이미지"/>
							</article>

							<article>
								<p className="subtitle">시스템 특장점</p>
								<div className="table-type table-row">
									<table>
									<caption>시스템 특장점 안내표</caption>
									<colgroup>
										<col style={{ width: "25%" }} />
										<col style={{ width: "auto" }} />
									</colgroup>

									<tbody>
										<tr>
										<th scope="row">
											고객관점의 <br />
											UI/UX지원
										</th>
										<td>
											<ul>
											<li>✔ 고객의 목적(여·수신 상품가입, 뱅킹관리 등)에 충실한 서비스 구성 및 배치</li>
											<li>✔ 다양한 모바일 환경과 사용자의 연령층을 고려한 UI 구조 적용</li>
											<li>✔ 원활한 서비스 전개를 위한 최적화된 서비스 플로우 구현</li>
											<li>✔ 서비스 이탈 요소를 최소화하여 서비스 체류 시간 확보</li>
											</ul>
										</td>
										</tr>

										<tr>
										<th scope="row">
											All-in-one <br />
											통합개발환경지원
										</th>
										<td>
											<ul>
											<li>✔ 개발 표준 Library 및 템플릿 지원</li>
											<li>✔ 플랫폼 종속성 배제한 확장성 높은 구조</li>
											<li>✔ 신뢰성과 보안성이 보장된 오픈소스 지원 및 3rd Party 연동 지원</li>
											<li>✔ Android, iOS 멀티플랫폼 지원</li>
											</ul>
										</td>
										</tr>

										<tr>
										<th scope="row">
											금융권 스마트뱅킹 <br />
											구축경험활용
										</th>
										<td>
											<ul>
											<li>✔ 저축은행, 카드사, 보험사, 여신전문기관 APP/모바일웹 구축 경험 활용</li>
											<li>✔ Open API, 이기종, 계정계 등 다양한 인터페이스 경험</li>
											<li>✔ 위험 요소 사전 차단</li>
											<li>✔ 금융권 SI 구축 경험을 활용한 노하우 적극 활용</li>
											</ul>
										</td>
										</tr>

										<tr>
										<th scope="row">
											개방적이고 확장성 높은 <br />
											아키텍처 구조
										</th>
										<td>
											<ul>
											<li>✔ 오픈소스 기반의 아키텍처로 솔루션 라이선스 제약 최소화, 운영 및 유지보수 생산성 증대</li>
											<li>✔ 확장성/유연성 있는 구조로 빠르게 변화하는 IT 환경에 대응</li>
											<li>✔ 검증된 오픈소스를 사용함으로써 신뢰성/안전성 강화</li>
											<li>✔ 기술의 호환성 및 시스템 간 통합에 용이</li>
											</ul>
										</td>
										</tr>
									</tbody>
									</table>
								</div>
							</article>
							<div className="subtitle">구축사례</div>
								<img src="/asset/img/subC/img_smartbanking_02.png" alt="시스템구축방안 방식에 대한 이미지"/>
						</div>
					)}

				{/* 시스템구축방안 */}
					{activeTab === 2 && (
						<div>
							<article>
							<p className="subtitle">시스템구축방안</p>
							<p className="txt-wrap">
								GnB 차세대뱅킹시스템은 금융기관을 위한 몇 개의 제품군으로 구성되어 있으며 각 제품군들은 독립된 모듈로 이루어져 있어
								다양한 규모의 금융기관 환경에서도 선별 가능한 맞춤형 시스템을 제공합니다.
							</p>
							</article>
							<article>
							<div className="subtitle">커스터마이징 방안</div>
							<img src="/asset/img/subC/img_product_01_5.png" alt="커스터마이징 방안 이미지" />
							</article>
							<article>
								<div className="subtitle">Componet 별로 선택 가능한 제품군</div>
								{/* <div className="modal-zoom mo">
									<button type="button" className="btn-sm btn-info popup-open" onclick="openModalImg('img3')">이미지 확대하기</button>
								</div> */}
								<img src="/asset/img/subC/img_product_01_6.png" alt="차세대 뱅킹시스템의 종류에 대한 이미지"/>
							</article>
							<article>
								<p className="subtitle">타 금융기관 합병 시 적용 방안</p>
								<div className="table-type table-row">
									<table>
										<caption>타 금융기관 합병 시 시스템구축 적용 방안에 관한 안내표</caption>
										<colgroup>
											<col style={{width: "25%"}}/>
											<col style={{width: "*"}}/>
										</colgroup>
										<tbody>
											<tr>
												<th scope="row">개념</th>
												<td>다수의 법인으로 구성된 연합 금융기관에 적용할 수 있는 가장 이상적인 시스템</td>
											</tr>
											<tr>
												<th scope="row">방식</th>
												<td>Application Server는 중앙에 집중시켜 표준화된 프로세스를 적용하되, 각 법인별 특성을 지원할 수 있도록 웹서버와 데이터서버를 분리시켜 처리하는 방식</td>
											</tr>
											<tr>
												<th scope="row">효과</th>
												<td>최고 경영층의 분석자료 및 전산관리는 통합을 하고, 각 법인별 처리 및 데이터는 분산을 시킴으로써 시스템 관리 및 운영에 대한 효율성과 각 법인별 데이터 및 처리의 독립성을 동시에 제공</td>
											</tr>
										</tbody>
									</table>
								</div>
							</article>
							<article>
								<div className="modal-zoom mo">
									{/* <button type="button" className="btn-sm btn-info popup-open" onclick="openModalImg('img4')">이미지 확대하기</button> */}
								</div>
								<img src="/asset/img/subC/img_product_01_7.png" alt="타 금융기관 합병 시 시스템구축방안에 관한 이미지"/>
							</article>
						</div>
					)}
			  </div>
			</div>
		  </div>
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE02000S;
